import React, { Component } from 'react';
import { Input } from 'components/antd';
import { ThemeContext } from 'app-themes';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { get, last, without, isEmpty } from 'lodash-es';

export interface NameInputData {
	firstName?: string;
	lastName?: string;
	fullName?: string;
}

interface Props {
	initialValue: NameInputData;
	form: WrappedFormUtils;
	keyName?: string;
	required: boolean;
	onChange?: () => void;
}

export class NameInput extends Component<Props> {
	static contextType = ThemeContext;
	static defaultProps = {
		required: true,
		initialValue: {
			firstName: undefined,
			lastName: undefined,
			fullName: undefined,
		},
	};

	getName = (ownName: string) => {
		const { keyName } = this.props;
		if (keyName) {
			return `${keyName}[${ownName}]`;
		}
		return ownName;
	};

	getInitialFullName = () => {
		const { initialValue } = this.props;
		const fullName = get(initialValue, 'fullName', '') || '';
		if (fullName) {
			return `${fullName.trim()}`.trim();
		}

		const firstName = get(initialValue, 'firstName', '') || '';
		const lastName = get(initialValue, 'lastName', '') || '';

		return `${firstName.trim()} ${lastName.trim()}`.trim();
	};

	hasFullName = () => {
		const { initialValue } = this.props;

		return initialValue.hasOwnProperty('fullName');
	};

	onUpdate = () => {
		const values = this.props.form.getFieldValue(this.getName('fullName'));
		const initial = this.getInitialFullName();
		if (typeof values === 'string') {
			if (values !== initial) {
				if (!this.hasFullName()) {
					const arrayName = values.split(' ').filter(f => f.trim() !== '');
					if (isEmpty(arrayName)) {
						this.props.form.setFieldsValue({
							[this.getName('firstName')]: undefined,
							[this.getName('lastName')]: undefined,
						});
						this.updateValidation();
						return;
					}
					if (arrayName.length === 1) {
						this.props.form.setFieldsValue({
							[this.getName('firstName')]: arrayName[0],
							[this.getName('lastName')]: undefined,
						});
						this.updateValidation();
						return;
					}
					const lastName = last(arrayName);
					const firstName = without(arrayName, lastName).join(' ');
					this.props.form.setFieldsValue({
						[this.getName('firstName')]: firstName,
						[this.getName('lastName')]: lastName,
					});
					this.updateValidation();
				} else {
					this.props.form.setFieldsValue({
						[this.getName('fullName')]: values,
					});
					this.updateValidation();
				}
			}
		}
	};

	updateValidation = () => {
		let fields = [this.getName('firstName'), this.getName('lastName')];
		if (this.hasFullName()) {
			fields = [this.getName('fullName')];
		}
		this.props.form.validateFields(fields, {
			force: true,
		});
	};

	render() {
		const { initialValue, form, required } = this.props;
		const { getFieldDecorator } = form;
		return (
			<div>
				{getFieldDecorator(this.getName('fullName'), {
					initialValue: this.getInitialFullName(),
					rules: [
						{
							required,
							whitespace: true,
						},
					],
				})(<Input onChange={() => setTimeout(this.onUpdate, 0)} />)}

				{getFieldDecorator(this.getName('firstName'), {
					initialValue: initialValue.firstName,
					rules: [
						{
							required,
							whitespace: true,
						},
					],
				})(<Input type={'hidden'} />)}
				{getFieldDecorator(this.getName('lastName'), {
					initialValue: initialValue.lastName,
					rules: [
						{
							required,
							whitespace: true,
						},
					],
				})(<Input type={'hidden'} />)}
			</div>
		);
	}
}
